/**
 * 路由
 */
export default {
  routes: [{
    path: '/',
    redirect: '/cus_day'
  }, { // 选择门店
    path: '/choose_store',
    component: resolve => import('../modules/choose_store').then(resolve),
    meta: {
      title: '选择门店'
    }
  }, { // 导航页
    path: '/navigation',
    component: resolve => import('../modules/navigation/Index').then(resolve),
    meta: {
      title: '导航'
    }
  }, { // 今日到店车主
    path: '/cus_day',
    component: resolve => import('../modules/cus/Day').then(resolve),
    meta: {
      title: '今日到店车主',
      needLoading: true
    }
  }, {
    path: '/cus_info',
    component: resolve => import('../modules/cus/Info').then(resolve),
    meta: {
      title: '客户详情'
    }
  }, {
    path: '/cus_succ/:status',
    component: resolve => import('../modules/cus/Succ').then(resolve),
    meta: {
      title: '提交成功'
    }
  }, { // 车险管理
    path: '/insurance_manage',
    component: resolve => import('../modules/insurance/autoInsurance').then(resolve),
    meta: {
      title: '续保招揽'
    }
  }, {
    path: '/card_manage',
    component: resolve => import('../modules/cou/CardVoucherManage').then(resolve),
    meta: {
      title: '市场营销'
    }
  }, { // 续保预存
    path: '/cou_check',
    component: resolve => import('../modules/cou/Check').then(resolve),
    meta: {
      title: '待审核列表'
    }
  }, { // 续保新报价单详情
    path: '/renewal_detail/:quote_id',
    component: resolve => import('../modules/cou/RenewalDetail').then(resolve),
    meta: {
      title: '报价单详情'
    }
  }, {
    path: '/cou_detail/:code',
    component: resolve => import('../modules/cou/Detail').then(resolve),
    meta: {
      title: '优惠券'
    }
  }, {
    path: '/cou_ver',
    component: resolve => import('../modules/cou/Ver').then(resolve),
    meta: {
      title: '卡券核销'
    }
  }, { // 礼品卡核销
    path: '/gift_detail/:code',
    component: resolve => import('../modules/gift/CardDetail').then(resolve),
    meta: {
      title: '礼品卡'
    }
  }, {
    path: '/appointment/index',
    component: resolve => import('../modules/appointment/index').then(resolve),
    meta: {
      title: '定保招揽'
    }
  }, {
    path: '/appointment/list/type/all',
    component: resolve => import('../modules/appointment/List').then(resolve),
    meta: {
      title: '全部预约'
    }
  }, {
    path: '/appointment/list/type/today',
    component: resolve => import('../modules/appointment/List').then(resolve),
    meta: {
      title: '今日预约'
    }
  }, {
    path: '/appointment/list/confirm/:isConfirmed',
    component: resolve => import('../modules/appointment/List').then(resolve),
    meta: {
      title: '待确认'
    }
  }, {
    path: '/appointment/detail/:id',
    component: resolve => import('../modules/appointment/Detail').then(resolve),
    meta: {
      title: '预约详情'
    }
  }, {
    path: '/appointment/updateOrder/:id',
    component: resolve => import('../modules/appointment/UpdateOrder').then(resolve),
    meta: {
      title: '更改预约'
    }
  }, {
    path: '/appointment/OverTimeConfirm/:id',
    component: resolve => import('../modules/appointment/OverTimeConfirm').then(resolve),
    meta: {
      title: '预约超时处理'
    }
  }, {
    path: '/appointment/newAppointment',
    component: resolve => import('../modules/appointment/NewAppointment').then(resolve),
    meta: {
      title: '养修预约'
    }
  }, {
    path: '/appointment/ReceptionResult',
    component: resolve => import('../modules/appointment/ReceptionResult').then(resolve),
    meta: {
      title: '接待结果'
    }
  }, {
    path: '/maintenance/trial',
    component: resolve => import('../modules/appointment/MaintenanceTrial').then(resolve),
    meta: {
      title: '保养日期试算'
    }
  }, {
    path: '/appointment/suc',
    component: resolve => import('../modules/appointment/Suc').then(resolve),
    meta: {
      title: '已预约'
    }
  }, {
    path: '/appointment/daily',
    component: resolve => import('../modules/appointment/Daily').then(resolve),
    meta: {
      title: '简报详情'
    }
  }, {
    path: '/leaveRegister/index',
    component: resolve => import('../modules/leaveRegister/Index').then(resolve),
    meta: {
      title: '车辆有牌离店登记'
    }
  }, {
    path: '/leaveRegisterNotPlate/index',
    component: resolve => import('../modules/leaveRegisterNotPlate/Index').then(resolve),
    meta: {
      title: '无牌离店'
    }
  }, {
    path: '/carregister/index',
    component: resolve => import('../modules/carRegister/Index').then(resolve),
    meta: {
      title: '车辆有牌到店登记'
    }
  }, {
    path: '/carregister/success',
    component: resolve => import('../modules/carRegister/Suc').then(resolve),
    meta: {
      title: '车辆有牌到店登记'
    }
  }, {
    path: '/carregister/record',
    component: resolve => import('../modules/carRegister/Record').then(resolve),
    meta: {
      title: '客户详情'
    }
  }, {
    path: '/carregister/salesnote',
    component: resolve => import('../modules/carRegister/SalesNote').then(resolve),
    meta: {
      title: '我的客户'
    }
  }, {
    path: '/carregister/addRegister',
    component: resolve => import('../modules/carRegister/AddRegister').then(resolve),
    meta: {
      title: '新增客户'
    }
  }, {
    path: '/carregister/addNotes',
    component: resolve => import('../modules/carRegister/AddNotes').then(resolve),
    meta: {
      title: '添加笔记'
    }
  }, {
    path: '/carregister/clue',
    component: resolve => import('../modules/carRegister/clue').then(resolve),
    meta: {
      title: '线索'
    }
  }, {
    path: '/carregister/car',
    component: resolve => import('../modules/carRegister/Car').then(resolve),
    meta: {
      title: '选择进店车辆'
    }
  }, { // 车辆道闸
    path: '/barriergate/check/list',
    component: resolve => import('../modules/barriergate/CheckList').then(resolve),
    meta: {
      title: '与我相关'
    }
  }, {
    path: '/barriergate/all/list',
    component: resolve => import('../modules/barriergate/AllList').then(resolve),
    meta: {
      title: '全部车辆'
    }
  }, {
    path: '/barriergate/unlabeled/discharging',
    component: resolve => import('../modules/barriergate/UnlabeledDischarging.vue').then(resolve),
    meta: {
      title: '无牌放行'
    }
  }, {
    path: '/new/back/page',
    component: resolve => import('../modules/newBackPage/index.vue').then(resolve),
    meta: {
      title: ''
    }
  }, {
    path: '/barriergate/create/:id',
    component: resolve => import('../modules/barriergate/CreateFlow').then(resolve),
    meta: {
      title: '发起放行'
    }
  }, {
    path: '/barriergate/create/succ/:sessionKey',
    component: resolve => import('../modules/barriergate/Succ').then(resolve),
    meta: {
      title: '发起成功'
    }
  }, {
    path: '/barriergate/flow/detail/:id/:process_id',
    component: resolve => import('../modules/barriergate/FlowDetail').then(resolve),
    meta: {
      title: '审核进度'
    }
  }, {
    path: '/barriergate/audit/progress/:id/:process_id',
    component: resolve => import('../modules/barriergate/AuditProgress').then(resolve),
    meta: {
      title: '审核进度'
    }
  }, {
    path: '/barriergate/trajectory/detail/:id/:process_id',
    component: resolve => import('../modules/barriergate/TrajectoryDetail').then(resolve),
    meta: {
      title: '车辆轨迹'
    }
  }, {
    path: '/barriergate/action_result',
    component: resolve => import('../modules/barriergate/ActionResult').then(resolve),
    meta: {
      title: '撤回成功'
    }
  }, { // 短信回复
    path: '/sms/:id',
    component: resolve => import('../modules/sms/Reply').then(resolve),
    meta: {
      title: '短信回复'
    }
  }, { // 二手车项目
    path: '/usedcar/index',
    component: resolve => import('../modules/usedcar/Index').then(resolve),
    meta: {
      title: '4S店二手车'
    }
  },
  // 评估跟进
  // {
  //   path: '/usedcar/carlist',
  //   component: resolve => import('../modules/usedcar/CarList').then(resolve),
  //   meta: {
  //     title: '二手车',
  //     isParent: true
  //   },
  //   children: [
  //     // 跟进详情
  //     {
  //       path: 'traceDetail/:id',
  //       component: resolve => import('../modules/usedcar/TraceDetail').then(resolve),
  //       meta: {
  //         title: '二手车跟进详情'
  //       }
  //     }
  //   ]
  // },
  {
    path: '/storeVehicle/index',
    component: resolve => import('../modules/usedcar/storeVehicleIndex').then(resolve),
    meta: {
      title: '车流管理'
    }
  },
  // 车辆转化
  // {
  //   path: '/usedcar/storevehicle',
  //   component: resolve => import('../modules/usedcar/storeVehicle').then(resolve),
  //   meta: {
  //     title: '到店车辆转化',
  //     isParent: true
  //   },
  //   children: [
  //     // 新建线索
  //     {
  //       path: 'submit',
  //       component: resolve => import('../modules/usedcar/Submit').then(resolve),
  //       meta: {
  //         'title': '提交二手车线索'
  //       }
  //     },
  //     // 查看线索
  //     {
  //       path: 'traceDetail/:id',
  //       component: resolve => import('../modules/usedcar/TraceDetail').then(resolve),
  //       meta: {
  //         title: '二手车跟进详情'
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/usedcar/cardetail/:id',
  //   redirect: '/usedcar/traceDetail/:id'
  // }, {
  //   path: '/usedcar/traceDetail/:id',
  //   component: resolve => import('../modules/usedcar/TraceDetail').then(resolve),
  //   meta: {
  //     title: '二手车跟进详情'
  //   }
  // }, {
  //   path: '/usedcar/previewer/:id',
  //   component: resolve => import('../modules/usedcar/Previewer').then(resolve),
  //   meta: {
  //     title: '图片预览'
  //   }
  // }, {
  //   path: '/usedcar/operate/:id/:btnValue',
  //   component: resolve => import('../modules/usedcar/Operate').then(resolve),
  //   meta: {
  //     title: '二手车操作'
  //   }
  // },
  // {
  //   path: '/usedcar/submit',
  //   component: resolve => import('../modules/usedcar/Submit').then(resolve),
  //   meta: {
  //     'title': '提交二手车线索'
  //   }
  // },
  // {
  //   path: '/usedcar/addFollowup/:id',
  //   component: resolve => import('../modules/usedcar/AddFollowup').then(resolve),
  //   meta: {
  //     'title': '新增联系记录'
  //   }
  // }, {
  //   path: '/usedcar/success/:id',
  //   component: resolve => import('../modules/usedcar/Suc').then(resolve),
  //   meta: {
  //     'title': '已提交'
  //   }
  // },
  // 线索车辆 - 发现本品
  // {
  //   path: '/usedcar/ownBrand/list',
  //   component: resolve => import('../modules/usedcar/ownBrandList').then(resolve),
  //   meta: {
  //     'title': '发现本品',
  //     isParent: true
  //   },
  //   children: [
  //     // 车辆详情
  //     {
  //       path: 'detail/:id',
  //       component: resolve => import('../modules/usedcar/ownBrandDetail').then(resolve),
  //       meta: {
  //         'title': '车辆详情'
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/usedcar/reference/list/:id',
  //   component: resolve => import('../modules/usedcar/referenceList').then(resolve),
  //   meta: {
  //     'title': '价格参考'
  //   }
  // }, {
  //   path: '/usedcar/reference/detail/:id',
  //   component: resolve => import('../modules/usedcar/referenceDetail').then(resolve),
  //   meta: {
  //     'title': '车辆详情'
  //   }
  // }, {
  //   path: '/usedcar/inquiry/:id',
  //   component: resolve => import('../modules/usedcar/Inquiry').then(resolve),
  //   meta: {
  //     'title': '查询历史车况'
  //   }
  // }, {
  //   path: '/usedcar/inquiry/suc/:id',
  //   component: resolve => import('../modules/usedcar/InquirySuc').then(resolve),
  //   meta: {
  //     'title': '支付成功'
  //   }
  // }, {
  //   path: '/usedcar/inquiry/process/:id',
  //   component: resolve => import('../modules/usedcar/InquiryProcess').then(resolve),
  //   meta: {
  //     'title': '查询结果'
  //   }
  // }, {
  //   path: '/usedcar/inquiry/protocol/index',
  //   component: resolve => import('../modules/usedcar/InquiryProtocol').then(resolve),
  //   meta: {
  //     'title': '相关协议'
  //   }
  // }, {
  //   path: '/usedcar/inquiry/protocol/chaDoctor',
  //   component: resolve => import('../modules/usedcar/InquiryProtocolChaDoctor').then(resolve),
  //   meta: {
  //     'title': '查博士免责条款'
  //   }
  // }, {
  //   path: '/usedcar/inquiry/protocol/composite',
  //   component: resolve => import('../modules/usedcar/InquiryProtocolComposite').then(resolve),
  //   meta: {
  //     'title': '历史车况综合版协议'
  //   }
  // }, {
  //   path: '/usedcar/inquiry/course/rechangeCourse',
  //   component: resolve => import('../modules/usedcar/InquiryRechargeCourse.vue').then(resolve),
  //   meta: {
  //     'title': '如何充值'
  //   }
  // },
  // 车辆询价、线索询价
  {
    path: '/inquiry/inquiryList/:inquirySource',
    component: resolve => import('../modules/inquiry/InquiryList').then(resolve),
    meta: {
      'title': '询价列表',
      isParent: true
    },
    children: [
      // 询价信息
      {
        path: 'inquiryInfo/:id/:source',
        component: resolve => import('../modules/inquiry/InquiryInfo').then(resolve),
        meta: {
          'title': '询价信息'
        }
      },
      // 线索询价 车辆询价、车辆详情
      {
        path: 'evaluateReport/:id/:source',
        component: resolve => import('../modules/auction/carInfo/EvaluateReport').then(resolve),
        meta: {
          title: '评估详情'
        }
      },
      // 线索详情
      {
        path: 'detail/:id',
        component: resolve => import('../modules/inquiry/Detail').then(resolve),
        meta: {
          'title': '二手车'
        }
      }
    ]
  },
  {
    path: '/inquiry/submit/:id/:source',
    component: resolve => import('../modules/inquiry/Submit').then(resolve),
    meta: {
      'title': '提交询价'
    }
  }, {
    path: '/inquiry/inquiryInfo/:id/:source',
    component: resolve => import('../modules/inquiry/InquiryInfo').then(resolve),
    meta: {
      'title': '询价信息'
    }
  }, {
    path: '/inquiry/carstore',
    component: resolve => import('../modules/inquiry/CarStore').then(resolve),
    meta: {
      'title': '选择车商'
    }
  }, {
    path: '/inquiry/success/:id/:source',
    component: resolve => import('../modules/inquiry/InquirySuc').then(resolve),
    meta: {
      'title': '已发起询价'
    }
  }, {
    path: '/inquiry/detail/:id',
    component: resolve => import('../modules/inquiry/Detail').then(resolve),
    meta: {
      'title': '二手车'
    }
  }, {
    path: '/car/brand',
    component: resolve => import('../modules/car/Brand').then(resolve),
    meta: {
      'title': '选择品牌'
    }
  }, {
    path: '/car/series/:brandId',
    component: resolve => import('../modules/car/Series').then(resolve),
    meta: {
      title: '选择车型'
    }
  }, {
    path: '/car/model/:seriesId',
    component: resolve => import('../modules/car/Model').then(resolve),
    meta: {
      title: '排量/年款'
    }
  }, {
    path: '/car/color',
    component: resolve => import('../modules/car/Color').then(resolve),
    meta: {
      title: '车颜色'
    }
  },
  // 全部车辆
  // {
  //   path: '/auction/carmanage',
  //   component: resolve => import('../modules/auction/CarManage').then(resolve),
  //   meta: {
  //     title: '车辆管理',
  //     isParent: true
  //   },
  //   children: [
  //     // 车辆详情
  //     {
  //       path: 'statudetail/:id',
  //       component: resolve => import('../modules/auction/StatuDetail').then(resolve),
  //       meta: {
  //         title: '二手车'
  //       }
  //     },
  //     // 询价
  //     {
  //       path: 'inquiry/submit/:id/:source',
  //       component: resolve => import('../modules/inquiry/Submit').then(resolve),
  //       meta: {
  //         'title': '提交询价'
  //       }
  //     },
  //     // 询价 - 已发起询价
  //     {
  //       path: 'inquiry/success/:id/:source',
  //       component: resolve => import('../modules/inquiry/InquirySuc').then(resolve),
  //       meta: {
  //         'title': '已发起询价'
  //       }
  //     },
  //     // 拍卖
  //     {
  //       path: 'confirm/:id',
  //       component: resolve => import('../modules/auction/Confirm').then(resolve),
  //       meta: {
  //         title: '确认提交拍卖'
  //       }
  //     },
  //     // 拍卖 - 已提交
  //     {
  //       path: 'confirmed',
  //       component: resolve => import('../modules/auction/Confirmed').then(resolve),
  //       meta: {
  //         title: '已提交'
  //       }
  //     },
  //     // 出库
  //     {
  //       path: 'outbound/index/:id',
  //       component: resolve => import('../modules/outBound/Index').then(resolve),
  //       meta: {
  //         title: '车辆出库记录'
  //       }
  //     },
  //     // 零售出库
  //     {
  //       path: 'outbound/retail/:id',
  //       component: resolve => import('../modules/outBound/Retail').then(resolve),
  //       meta: {
  //         title: '提交零售'
  //       }
  //     },
  //     // 批售出库
  //     {
  //       path: 'outbound/batch_sale/:id',
  //       component: resolve => import('../modules/outBound/BatchSale').then(resolve),
  //       meta: {
  //         title: '提交批售'
  //       }
  //     },
  //     // 报废出库
  //     {
  //       path: 'outbound/scrap/:id',
  //       component: resolve => import('../modules/outBound/Scrap').then(resolve),
  //       meta: {
  //         title: '提交报废'
  //       }
  //     },
  //     // 特殊出库
  //     {
  //       path: 'outbound/special/:id',
  //       component: resolve => import('../modules/outBound/Special').then(resolve),
  //       meta: {
  //         title: '提交特殊出库'
  //       }
  //     },
  //     // 流拍撮合、询价撮合
  //     {
  //       path: 'auction/select/:id/:type',
  //       component: resolve => import('../modules/auction/MatchSelect').then(resolve),
  //       meta: {
  //         title: '撮合选择'
  //       }
  //     }
  //   ]
  // },
  {
    path: '/auction/confirm/:id',
    component: resolve => import('../modules/auction/Confirm').then(resolve),
    meta: {
      title: '确认提交拍卖'
    }
  }, {
    path: '/auction/confirmed',
    component: resolve => import('../modules/auction/Confirmed').then(resolve),
    meta: {
      title: '已提交'
    }
  }, {
    path: '/auction/detail/:id',
    component: resolve => import('../modules/auction/Detail').then(resolve),
    meta: {
      title: '车商信息'
    }
  }, {
    path: '/auction/info/:id',
    component: resolve => import('../modules/auction/AuctionEvaluateReport').then(resolve),
    meta: {
      title: '车辆详情'
    }
  }, {
    path: '/auction/orderdetail/:id',
    component: resolve => import('../modules/auction/OrderDetail').then(resolve),
    meta: {
      title: '订单详情'
    }
  }, {
    path: '/auction/statudetail/:id',
    component: resolve => import('../modules/auction/StatuDetail').then(resolve),
    meta: {
      title: '二手车'
    }
  },
  // 车辆拍卖
  // {
  //   path: '/auction/manage',
  //   component: resolve => import('../modules/auction/Manage').then(resolve),
  //   meta: {
  //     title: '拍卖管理',
  //     isParent: true
  //   },
  //   children: [
  //     // 车辆详情
  //     {
  //       path: 'info/:id',
  //       component: resolve => import('../modules/auction/AuctionEvaluateReport').then(resolve),
  //       meta: {
  //         title: '车辆详情'
  //       }
  //     },
  //     // 编辑拍卖
  //     {
  //       path: 'confirm/:id',
  //       component: resolve => import('../modules/auction/Confirm').then(resolve),
  //       meta: {
  //         title: '确认提交拍卖'
  //       }
  //     },
  //     // 编辑车辆
  //     {
  //       path: 'carInfo/edit/:id/:source',
  //       component: resolve => import('../modules/auction/carInfo/Edit').then(resolve),
  //       meta: {
  //         title: '车辆信息编辑'
  //       }
  //     },
  //     // 出价信息
  //     {
  //       path: 'offer/:id',
  //       component: resolve => import('../modules/auction/Offer').then(resolve),
  //       meta: {
  //         title: '出价信息'
  //       }
  //     }
  //   ]
  // },
  {
    path: '/auction/offer/:id',
    component: resolve => import('../modules/auction/Offer').then(resolve),
    meta: {
      title: '出价信息'
    }
  }, {
    path: '/auction/orderclose/:order_id',
    component: resolve => import('../modules/auction/OrderClose').then(resolve),
    meta: {
      title: '关闭交易'
    }
  }, {
    path: '/auction/paid/:order_id',
    component: resolve => import('../modules/auction/Paid').then(resolve),
    meta: {
      title: '已收款'
    }
  }, {
    path: '/auction/rules',
    component: resolve => import('../modules/auction/Rules').then(resolve),
    meta: {
      title: '拍卖规则'
    }
  }, { // 车辆扫码
    path: '/carqrcode/:serveCarId',
    component: resolve => import('../modules/carQrCode/QrCode').then(resolve),
    meta: {
      title: '车辆扫码'
    }
  }, { // 数据统计
    path: '/manageAnalysis/carVisitDaily',
    component: resolve => import('../modules/analysis/CarVisitDaily').then(resolve),
    meta: {
      title: '车辆进出店统计'
    }
  }, {
    path: '/manageAnalysis/carVisitDetail/:id/:date/:flag/:isDay',
    component: resolve => import('../modules/analysis/CarVisitDetail').then(resolve),
    meta: {
      title: '车辆进出店详情'
    }
  },
  {
    path: '/tool/guestMeals',
    component: resolve => import('../modules/tool/GuestMeals').then(resolve),
    meta: {
      title: '客餐排队'
    }
  },
  {
    path: '/manageAnalysis/fansAnalysis',
    component: resolve => import('../modules/analysis/FansAnalysis').then(resolve),
    meta: {
      title: '粉丝运营统计'
    }
  }, {
    path: '/manageAnalysis/fansDetailDaily/:id/:date/:flag/:isDay',
    component: resolve => import('../modules/analysis/FansDetailDaily').then(resolve),
    meta: {
      title: '粉丝运营详情'
    }
  },
  {
    path: '/manageAnalysis/carBusiness',
    component: resolve => import('../modules/analysis/CarBusiness').then(resolve),
    meta: {
      title: '二手车业务统计'
    }
  }, {
    path: '/manageAnalysis/insurance', // 集团统计
    component: resolve => import('../modules/analysis/Insurance').then(resolve),
    meta: {
      title: '续保统计'
    }
  }, {
    path: '/manageAnalysis/insurance/:id', // 门店统计
    component: resolve => import('../modules/analysis/InsuranceStore').then(resolve),
    meta: {
      title: '续保统计'
    }
  }, {
    path: '/manageAnalysis/index',
    component: resolve => import('../modules/analysis/Index').then(resolve),
    meta: {
      title: '数据中心'
    }
  }, {
    path: '/saleAnalysis/index',
    component: resolve => import('../modules/salemanage/manage/index').then(resolve),
    meta: {
      title: '销售管理'
    }
  }, {
    path: '/saleAnalysis/shopCustomers',
    component: resolve => import('../modules/analysis/ShopCustomers').then(resolve),
    meta: {
      title: '到店客户'
    }
  }, {
    path: '/saleAnalysis/salesConsultant',
    component: resolve => import('../modules/analysis/SalesConsultant').then(resolve),
    meta: {
      title: '销售顾问'
    }
  }, {
    path: '/saleAnalysis/dccFollowUp',
    component: resolve => import('../modules/analysis/DccFollowUp').then(resolve),
    meta: {
      title: 'DCC专员跟进'
    }
  }, {
    path: '/saleAnalysis/group',
    component: resolve => import('../modules/analysis/Group').then(resolve),
    meta: {
      title: '销售统计'
    }
  }, {
    path: '/saleAnalysis/dccclues',
    component: resolve => import('../modules/analysis/DccClue').then(resolve),
    meta: {
      title: 'DCC线索'
    }
  }, {
    path: '/saleAnalysis/saleCount',
    component: resolve => import('../modules/analysis/SaleCount').then(resolve),
    meta: {
      title: '销售统计'
    }
  }, { // A卡销售
    path: '/salemanage/entrance',
    component: resolve => import('../modules/salemanage/Entrance').then(resolve),
    meta: {
      title: '选择入口'
    }
  }, {
    path: '/salemanage/manage/mywork',
    component: resolve => import('../modules/salemanage/manage/MyWork').then(resolve),
    meta: {
      title: '我的工作台'
    }
  }, {
    path: '/salemanage/manage/datastatistics',
    component: resolve => import('../modules/salemanage/manage/DataStatistics').then(resolve),
    meta: {
      title: '数据统计'
    }
  }, {
    path: '/salemanage/manage/deal',
    component: resolve => import('../modules/salemanage/manage/Deal').then(resolve),
    meta: {
      title: '成交确认'
    }
  }, {
    path: '/salemanage/manage/review',
    component: resolve => import('../modules/salemanage/manage/Review').then(resolve),
    meta: {
      title: '战败审核'
    }
  }, {
    path: '/salemanage/staff/mywork',
    component: resolve => import('../modules/salemanage/staff/MyWork').then(resolve),
    meta: {
      title: '我的工作台'
    }
  }, {
    path: '/salemanage/staff/visitors',
    component: resolve => import('../modules/salemanage/staff/VisitorsInStore').then(resolve),
    meta: {
      title: '今日到店客流'
    }
  }, {
    path: '/salemanage/staff/reservation',
    component: resolve => import('../modules/salemanage/staff/ReservationInStore').then(resolve),
    meta: {
      title: '今日预约到店'
    }
  }, {
    path: '/salemanage/staff/todaycustomertask',
    component: resolve => import('../modules/salemanage/staff/TodayCustomerTask').then(resolve),
    meta: {
      title: '今日客户任务'
    }
  }, {
    path: '/salemanage/staff/allcustomertask',
    component: resolve => import('../modules/salemanage/staff/AllCustomerTask').then(resolve),
    meta: {
      title: '全部客户任务'
    }
  }, {
    path: '/salemanage/staff/allcustomer',
    component: resolve => import('../modules/salemanage/staff/AllCustomer').then(resolve),
    meta: {
      title: '全部客户'
    }
  }, {
    path: '/salemanage/staff/todaycluetask',
    component: resolve => import('../modules/salemanage/staff/TodayClueTask').then(resolve),
    meta: {
      title: '今日线索任务'
    }
  }, {
    path: '/salemanage/staff/allcluetask',
    component: resolve => import('../modules/salemanage/staff/AllClueTask').then(resolve),
    meta: {
      title: '全部线索任务'
    }
  }, {
    path: '/salemanage/staff/allclue',
    component: resolve => import('../modules/salemanage/staff/AllClue').then(resolve),
    meta: {
      title: '全部线索'
    }
  }, {
    path: '/salemanage/staff/showphone',
    component: resolve => import('../modules/salemanage/staff/ShowPhone').then(resolve),
    meta: {
      title: '关联客户'
    }
  }, {
    path: '/salemanage/staff/associatecustomer/:id',
    component: resolve => import('../modules/salemanage/staff/AssociateCustomer').then(resolve),
    meta: {
      title: '关联客户'
    }
  }, {
    path: '/salemanage/staff/customerarchives',
    component: resolve => import('../modules/salemanage/staff/CustomerArchives').then(resolve),
    meta: {
      title: '客户档案',
      description: '新建/详情'
    }
  }, {
    path: '/salemanage/staff/cluearchives',
    component: resolve => import('../modules/salemanage/staff/ClueArchives').then(resolve),
    meta: {
      title: '线索档案',
      description: '新建/详情'
    }
  }, {
    path: '/salemanage/staff/showcluearchives/:id',
    component: resolve => import('../modules/salemanage/staff/ShowClueArchives').then(resolve),
    meta: {
      title: '线索档案'
    }
  }, {
    path: '/salemanage/staff/addcluerecord/:id',
    component: resolve => import('../modules/salemanage/staff/AddClueRecord').then(resolve),
    meta: {
      title: '添加跟进记录'
    }
  }, {
    path: '/salemanage/staff/addcustomerrecord/:id',
    component: resolve => import('../modules/salemanage/staff/AddCustomerRecord').then(resolve),
    meta: {
      title: '添加跟进记录'
    }
  }, {
    path: '/salemanage/staff/customerarriverecord/:id',
    component: resolve => import('../modules/salemanage/staff/CustomerArriveRecord').then(resolve),
    meta: {
      title: '添加跟进记录',
      description: '到店客流-添加到店记录'
    }
  }, {
    path: '/salemanage/car/brands',
    component: resolve => import('../modules/salemanage/car/Brands').then(resolve),
    meta: {
      title: '选择品牌',
      description: '竞品车型'
    }
  }, {
    path: '/salemanage/car/intendbrands',
    component: resolve => import('../modules/salemanage/car/IntendBrands').then(resolve),
    meta: {
      title: '选择品牌',
      description: '意向车型'
    }
  }, {
    path: '/salemanage/car/series/:brandId',
    component: resolve => import('../modules/salemanage/car/Series').then(resolve),
    meta: {
      title: '选择车型'
    }
  }, {
    path: '/salemanage/car/models/:seriesId',
    component: resolve => import('../modules/salemanage/car/Model').then(resolve),
    meta: {
      title: '排量/年款'
    }
  }, {
    path: '/salemanage/car/inner',
    component: resolve => import('../modules/salemanage/car/Inner').then(resolve),
    meta: {
      title: '选择内饰色'
    }
  }, {
    path: '/salemanage/car/outer',
    component: resolve => import('../modules/salemanage/car/Outer').then(resolve),
    meta: {
      title: '选择车身色'
    }
  }, {
    path: '/salemanage/staff/sure/:id',
    component: resolve => import('../modules/salemanage/staff/Sure').then(resolve),
    meta: {
      title: '确认签单'
    }
  }, {
    path: '/salemanage/staff/fail/:id',
    component: resolve => import('../modules/salemanage/staff/Fail').then(resolve),
    meta: {
      title: '申请战败'
    }
  }, { // 领券码
    path: '/coupon/index',
    component: resolve => import('../modules/coupon/index').then(resolve),
    meta: {
      title: '领券码'
    }
  }, {
    path: '/gift_retreat/:id',
    component: resolve => import('../modules/giftCheck/Retreat').then(resolve),
    meta: {
      title: '退回审核'
    }
  }, {
    path: '/giftCheck/canUse',
    component: resolve => import('../modules/gift/Valid').then(resolve),
    meta: {
      title: '礼品卡'
    }
  }, {
    path: '/couponCheck/canUse',
    component: resolve => import('../modules/cou/Valid').then(resolve),
    meta: {
      title: '优惠券'
    }
  }, { // 车辆信息录入
    path: '/auction/carInfo/edit/:id/:source',
    component: resolve => import('../modules/auction/carInfo/Edit').then(resolve),
    meta: {
      title: '车辆信息编辑'
    }
  }, {
    path: '/auction/carInfo/photo/:id/:source',
    component: resolve => import('../modules/auction/carInfo/Photo').then(resolve),
    meta: {
      title: '图片信息'
    }
  }, {
    path: '/auction/carInfo/inspections/:id/:source',
    component: resolve => import('../modules/auction/carInfo/Inspections').then(resolve),
    meta: {
      title: '检测信息'
    }
  }, {
    path: '/auction/carInfo/recycle/:id/:source',
    component: resolve => import('../modules/auction/carInfo/Recycle').then(resolve),
    meta: {
      title: '收车信息'
    }
  }, {
    path: '/auction/carInfo/success/:id/:source',
    component: resolve => import('../modules/auction/carInfo/Suc').then(resolve),
    meta: {
      title: '成功'
    }
  }, {
    path: '/auction/carInfo/detail/:id/:source',
    component: resolve => import('../modules/auction/carInfo/Detail').then(resolve),
    meta: {
      title: '车辆信息'
    }
  }, {
    path: '/check/configReport/:id/:source',
    component: resolve => import('../modules/auction/carInfo/ConfigReport').then(resolve),
    meta: {
      title: '查看配置信息'
    }
  }, {
    path: '/check/inspectionsReport/:id/:source',
    component: resolve => import('../modules/auction/carInfo/InspectionsReport').then(resolve),
    meta: {
      title: '查看质检报告'
    }
  }, { // 保险模块 - 报价信息 - 旧入口
    path: '/insurance/quote/info/:id',
    component: resolve => import('../modules/insurance/quoteInfo').then(resolve),
    meta: {
      title: '报价信息'
    }
  }, { // 保险模块 - 报价信息 - 新入口
    path: '/insurance/quote/info/:id/:source',
    component: resolve => import('../modules/insurance/quoteInfo').then(resolve),
    meta: {
      title: '报价信息'
    }
  }, { // 保险模块 - 更新车辆保险信息
    path: '/insurance/updateInfo',
    component: resolve => import('../modules/insurance/updateInfo').then(resolve),
    meta: {
      title: '更新信息'
    }
  }, { // 保险模块 - 更新车辆保险信息结果页
    path: '/insurance/updateInfoResult/:status',
    component: resolve => import('../modules/insurance/updateInfoResult').then(resolve),
    meta: {
      title: '更新结果'
    }
  },
  // { // 查看二手车评估详情
  //   path: '/usedcar/evaluateReport/:id/:source',
  //   component: resolve => import('../modules/auction/carInfo/EvaluateReport').then(resolve),
  //   meta: {
  //     title: '评估详情'
  //   }
  // }, { // 查博士车况查询
  //   path: '/usedCar/carCondition',
  //   component: resolve => import('../modules/conditionReport/carConditionReport').then(resolve),
  //   meta: {
  //     title: '历史车况'
  //   }
  // }, { // 搜索指定内容
  //   path: '/usedCar/search/:source',
  //   component: resolve => import('../modules/search/searchSelect').then(resolve),
  //   meta: {
  //     title: '搜索指定内容'
  //   }
  // },
  // {
  //   path: '/usedcar/edit/ownerInfo',
  //   component: resolve => import('../modules/usedcar/editOwnerInfo').then(resolve),
  //   meta: {
  //     'title': '车主信息修改'
  //   }
  // },
  // 流拍撮合
  // {
  //   path: '/auction/match/manage',
  //   component: resolve => import('../modules/auction/MatchManage').then(resolve),
  //   meta: {
  //     title: '流拍撮合管理',
  //     isParent: true
  //   },
  //   children: [
  //     // 车辆详情
  //     {
  //       path: 'carinfo/:id',
  //       component: resolve => import('../modules/auction/MatchInfo').then(resolve),
  //       meta: {
  //         title: '撮合车辆详情'
  //       }
  //     },
  //     // 出价信息
  //     {
  //       path: 'offer/:id',
  //       component: resolve => import('../modules/auction/Offer').then(resolve),
  //       meta: {
  //         title: '出价信息'
  //       }
  //     },
  //     // 订单详情
  //     {
  //       path: 'order/:id',
  //       component: resolve => import('../modules/auction/MatchOrder').then(resolve),
  //       meta: {
  //         title: '撮合订单详情'
  //       }
  //     }
  //   ]
  // },
  // 询价撮合
  // {
  //   path: '/auction/enquiry/manage',
  //   component: resolve => import('../modules/auction/EnquiryManage').then(resolve),
  //   meta: {
  //     title: '询价撮合管理',
  //     isParent: true
  //   },
  //   children: [
  //     // 车辆详情
  //     {
  //       path: 'carinfo/:id',
  //       component: resolve => import('../modules/auction/MatchInfo').then(resolve),
  //       meta: {
  //         title: '撮合车辆详情'
  //       }
  //     },
  //     // 询价信息
  //     {
  //       path: 'inquiryInfo/:id/:source',
  //       component: resolve => import('../modules/inquiry/InquiryInfo').then(resolve),
  //       meta: {
  //         'title': '询价信息'
  //       }
  //     },
  //     // 订单详情
  //     {
  //       path: 'order/:id',
  //       component: resolve => import('../modules/auction/MatchOrder').then(resolve),
  //       meta: {
  //         title: '撮合订单详情'
  //       }
  //     }
  //   ]
  // },
  {
    path: '/auction/select/:id/:type',
    component: resolve => import('../modules/auction/MatchSelect').then(resolve),
    meta: {
      title: '撮合选择'
    }
  }, {
    path: '/auction/match/carinfo/:id',
    component: resolve => import('../modules/auction/MatchInfo').then(resolve),
    meta: {
      title: '撮合车辆详情'
    }
  }, {
    path: '/auction/match/order/:id',
    component: resolve => import('../modules/auction/MatchOrder').then(resolve),
    meta: {
      title: '撮合订单详情'
    }
  }, {
    path: '/auction/match/submit/:id',
    component: resolve => import('../modules/auction/SubmitMatch').then(resolve),
    meta: {
      title: '提交撮合'
    }
  }, {
    path: '/auction/match/suc/:id',
    component: resolve => import('../modules/auction/MatchSuc').then(resolve),
    meta: {
      title: '已提交撮合'
    }
  }, { // 车辆出库模块
    path: '/outbound/index/:id',
    component: resolve => import('../modules/outBound/Index').then(resolve),
    meta: {
      title: '车辆出库记录'
    }
  }, {
    path: '/outbound/retail/:id',
    component: resolve => import('../modules/outBound/Retail').then(resolve),
    meta: {
      title: '提交零售'
    }
  }, {
    path: '/outbound/batch_sale/:id',
    component: resolve => import('../modules/outBound/BatchSale').then(resolve),
    meta: {
      title: '提交批售'
    }
  }, {
    path: '/outbound/scrap/:id',
    component: resolve => import('../modules/outBound/Scrap').then(resolve),
    meta: {
      title: '提交报废'
    }
  }, {
    path: '/outbound/special/:id',
    component: resolve => import('../modules/outBound/Special').then(resolve),
    meta: {
      title: '提交特殊出库'
    }
  }, {
    path: '/outbound/succ/:id',
    component: resolve => import('../modules/outBound/Succ').then(resolve),
    meta: {
      title: '已提交'
    }
  }, { // 报废、零售、批售出库的车辆详情
    path: '/auction/outBound/carinfo/:id',
    component: resolve => import('../modules/auction/OutBoundInfo').then(resolve),
    meta: {
      title: ''
    }
  },
  // {
  //   path: '/outbound/manage',
  //   component: resolve => import('../modules/outBound/ManageList').then(resolve),
  //   meta: {
  //     title: '出库管理',
  //     isParent: true
  //   },
  //   children: [
  //     // 出库详情
  //     {
  //       path: 'detail/:id',
  //       component: resolve => import('../modules/outBound/Detail').then(resolve),
  //       meta: {
  //         title: ''
  //       }
  //     }
  //   ]
  // },
  {
    path: '/outbound/detail/:id',
    component: resolve => import('../modules/outBound/Detail').then(resolve),
    meta: {
      title: ''
    }
  }, {
    path: '/outbound/review/:id/:action/:role',
    component: resolve => import('../modules/outBound/Review').then(resolve),
    meta: {
      title: '出库审核'
    }
  },
  // {// 评价管理
  //   path: '/usedcar/reviewManage',
  //   component: resolve => import('../modules/reviewManage/ReviewList').then(resolve),
  //   meta: {
  //     title: '收到的评价'
  //   }
  // },
  // {// 评价页面
  //   path: '/usedcar/reviewSubmit/:id',
  //   component: resolve => import('../modules/reviewManage/ReviewSubmit').then(resolve),
  //   meta: {
  //     title: '本次交易评价'
  //   }
  // },
  // 过户管理模块
  // {
  //   path: '/transfer/manage',
  //   component: resolve => import('../modules/transfer/TransferManage').then(resolve),
  //   meta: {
  //     title: '过户管理',
  //     isParent: true
  //   },
  //   children: [
  //     // 过户资料
  //     {
  //       path: 'transferData/:transferId',
  //       component: resolve => import('../modules/transfer/TransferData').then(resolve),
  //       meta: {
  //         title: '过户资料'
  //       }
  //     },
  //     // 竞拍车辆详情
  //     {
  //       path: 'info/:id',
  //       component: resolve => import('../modules/auction/AuctionEvaluateReport').then(resolve),
  //       meta: {
  //         title: '车辆详情'
  //       }
  //     },
  //     // 竞拍订单详情
  //     {
  //       path: 'orderdetail/:id',
  //       component: resolve => import('../modules/auction/OrderDetail').then(resolve),
  //       meta: {
  //         title: '订单详情'
  //       }
  //     },
  //     // 流拍、询价撮合车辆详情
  //     {
  //       path: 'match/carinfo/:id',
  //       component: resolve => import('../modules/auction/MatchInfo').then(resolve),
  //       meta: {
  //         title: '撮合车辆详情'
  //       }
  //     },
  //     // 流拍、询价撮合订单详情
  //     {
  //       path: 'match/order/:id',
  //       component: resolve => import('../modules/auction/MatchOrder').then(resolve),
  //       meta: {
  //         title: '撮合订单详情'
  //       }
  //     }
  //   ]
  // },
  // 星睿排行榜
  {
    path: '/usedcar/rankList',
    component: resolve => import('../modules/usedcar/rankList/RankList').then(resolve),
    meta: {
      title: '星睿排行榜',
      isParent: true
    }
  },
  {
    path: '/usedcar/personalRank',
    component: resolve => import('../modules/usedcar/rankList/personalRank').then(resolve),
    meta: {
      title: '星睿排行榜',
      isParent: true
    }
  },
  {
    path: '/usedcar/storeRank',
    component: resolve => import('../modules/usedcar/rankList/storeRank').then(resolve),
    meta: {
      title: '星睿排行榜',
      isParent: true
    }
  },
  // 拍卖协议
  {
    path: '/protocol/auction',
    component: resolve => import('../modules/protocol/AuctionProtocol').then(resolve),
    meta: {
      title: '拍卖协议'
    }
  },
  // 撮合协议
  {
    path: '/protocol/match',
    component: resolve => import('../modules/protocol/MatchProtocol').then(resolve),
    meta: {
      title: '撮合协议'
    }
  },
  // 询价协议
  {
    path: '/protocol/inquiry',
    component: resolve => import('../modules/protocol/InquiryProtocol').then(resolve),
    meta: {
      title: '询价协议'
    }
  },
  {
    path: '/consultant_list',
    component: resolve => import('../modules/cou/ConsultantList').then(resolve),
    meta: {
      title: '顾问列表'
    }
  }, {
    path: '/marketing/activityCenter',
    component: resolve => import('../modules/marketing/activity/activityCenter').then(resolve),
    meta: {
      title: '活动中心'
    }
  }, {
    path: '/marketing/activityRank/:id',
    component: resolve => import('../modules/marketing/activity/activityRank').then(resolve),
    meta: {
      title: '排行榜'
    }
  }, {
    path: '/marketing/activityCustomer/:id',
    component: resolve => import('../modules/marketing/activity/activityCustomer').then(resolve),
    meta: {
      title: '我的客户'
    }
  }, {
    path: '/marketing/referral',
    component: resolve => import('../modules/marketing/referral/referral').then(resolve),
    meta: {
      title: '转介绍'
    }
  }, {
    path: '/aftersales/index',
    name: 'aftersalesIndex',
    component: resolve => import('../modules/aftersales/Index').then(resolve),
    meta: {
      eventTrackName: 'AFTERSALES/INDEX',
      title: '售后管理'
    }
  }, {
    path: '/aftersales/complement',
    name: 'aftersalesComplement',
    component: resolve => import('../modules/aftersales/ComplementUserInfo').then(resolve),
    meta: {
      eventTrackName: 'AFTERSALES/UPDATE',
      title: '售后管理'
    }
  }, {
    path: '/aftersales/carList',
    name: 'aftersalesCarList',
    component: resolve => import('../modules/aftersales/CarList').then(resolve),
    meta: {
      eventTrackName: 'AFTERSALES/CARLIST',
      title: '售后管理'
    }
  }, { // 卡券审核
    path: '/cardCheck/check',
    component: resolve => import('../modules/cardCheck/Check').then(resolve),
    meta: {
      title: '卡券审核'
    }
  }, { // 审核详情
    path: '/cardCheck/detail',
    component: resolve => import('../modules/cardCheck/Detail').then(resolve),
    meta: {
      title: '审核详情'
    }
  }, {
    path: '/aftersales/carInfo',
    name: 'aftersalesCarInfo',
    component: resolve => import('../modules/aftersales/CarInfo').then(resolve),
    meta: {
      eventTrackName: 'AFTERSALES/CARINFO',
      title: '售后管理'
    }
  }]
}
